<div class="message-outer" *ngIf="message">
    <img src="assets/icons/caution.svg"/>
    <p>{{ message }}</p>
</div>
